const getFormTitle = (
  id: string | undefined,
  recordName: string | undefined | null,
  entityName: string,
) => {
  if (!id || id === 'new') {
    return `New ${entityName}`;
  }

  if (!recordName) {
    return entityName;
  }

  return recordName;
};

export default getFormTitle;
